var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-alice",style:(_vm.whiteC && 'background-color: darkgray;')},[_c('div',{staticClass:"BottomTimer",style:(_vm.whiteC && 'background-color: white;'),attrs:{"id":"bottomTimer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }